export default {
    getIndex(arr,prop,val){
        var returnIdx=null;
        if (arr) {
            arr.forEach((item,itemIdx)=> {
                if (prop) {
                    if (item[prop]==val) {
                        returnIdx = itemIdx;
                    }
                }
                else {
                    if (item==val) {
                        returnIdx = itemIdx;
                    }
                }
            });
        }
        return returnIdx;
    },
    getItemInArray(arr,attr,val){
        var result = [];
        if (arr) {
            result = arr.filter(item=>{
                return (item[attr]==val);
            });
        }
        return result;
    },
    inArray(arr,needle){
        var result = [];
        if (arr) {
            result = arr.filter(item=>{
                return (item==needle);
            });
        }
        if (result.length > 0) {
            return true;
        }
        return false;
    },
    getArrIndex(arr,needle) {
        let idx = -1;
        if (arr) {
            for (var i=0;i<arr.length;i++){
                if (arr[i]==needle) {
                    idx = i;
                    continue;
                }
            }
        }
        return idx;
    },
    paginate (data,pageSize) {
        var pagedData = []
        if (data.length > 0) {
            var page = []
            data.forEach((item,itemIdx) => {
                if (page.length < pageSize) {
                    page.push(item)
                } else {
                    pagedData.push(page)
                    page = []
                    page.push(item)
                }
            })
            pagedData.push(page)
        }
        return pagedData
    },
    pageItems (pagedData) {
        var count = 0
        if (pagedData && pagedData.length > 0) {
            pagedData.forEach(pageItems => {
                count = count + pageItems.length
            })
        }
        return count
    }
}


// WEBPACK FOOTER //
// ./src/utilities/ArrayUtil.js